import { render, staticRenderFns } from "./DashboardClientGrantType.vue?vue&type=template&id=395a0437&"
import script from "./DashboardClientGrantType.vue?vue&type=script&lang=ts&"
export * from "./DashboardClientGrantType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('395a0437')) {
      api.createRecord('395a0437', component.options)
    } else {
      api.reload('395a0437', component.options)
    }
    module.hot.accept("./DashboardClientGrantType.vue?vue&type=template&id=395a0437&", function () {
      api.rerender('395a0437', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientDashboard/DashboardClientGrantType.vue"
export default component.exports